import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class Poll extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "tempOptions", void 0);
  }
  question() {
    return Model.attribute('question').call(this);
  }
  subtitle() {
    return Model.attribute('subtitle').call(this);
  }
  image() {
    return Model.attribute('image').call(this);
  }
  imageUrl() {
    return Model.attribute('imageUrl').call(this);
  }
  imageSrcset() {
    return Model.attribute('imageSrcset').call(this);
  }
  imageAlt() {
    return Model.attribute('imageAlt').call(this);
  }

  /** @deprecated Use imageSrcset() presence instead */
  isImageUpload() {
    return Model.attribute('isImageUpload').call(this);
  }
  hasEnded() {
    return Model.attribute('hasEnded').call(this);
  }
  endDate() {
    return Model.attribute('endDate', Model.transformDate).call(this);
  }
  publicPoll() {
    return Model.attribute('publicPoll').call(this);
  }
  hideVotes() {
    return Model.attribute('hideVotes').call(this);
  }
  allowChangeVote() {
    return Model.attribute('allowChangeVote').call(this);
  }
  allowMultipleVotes() {
    return Model.attribute('allowMultipleVotes').call(this);
  }
  ranked() {
    return Model.attribute('ranked').call(this);
  }
  maxVoteChanges() {
    return Model.attribute('maxVoteChanges').call(this);
  }
  myVoteChanges() {
    return Model.attribute('myVoteChanges').call(this);
  }
  maxVotes() {
    return Model.attribute('maxVotes').call(this);
  }
  voteCount() {
    return Model.attribute('voteCount').call(this);
  }
  canVote() {
    return Model.attribute('canVote').call(this);
  }
  canEdit() {
    return Model.attribute('canEdit').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
  canSeeVoters() {
    return Model.attribute('canSeeVoters').call(this);
  }
  canChangeVote() {
    return Model.attribute('canChangeVote').call(this);
  }
  options() {
    const options = Model.hasMany('options').call(this);
    return options ? options : [];
  }
  votes() {
    return Model.hasMany('votes').call(this);
  }
  myVotes() {
    const myVotes = Model.hasMany('myVotes').call(this);
    return myVotes ? myVotes : [];
  }
  pollGroup() {
    return Model.hasOne('pollGroup').call(this);
  }
  isGlobal() {
    return Model.attribute('isGlobal').call(this);
  }
  isHidden() {
    return computed('hiddenAt', hiddenAt => !!hiddenAt).call(this);
  }

  // TODO: These two don't make sense as of now
  isUnread() {
    return false;
  }
  publishedAt() {
    return Model.attribute('publishedAt', Model.transformDate).call(this);
  }
  scheduledPublishAt() {
    return Model.attribute('scheduledPublishAt', Model.transformDate).call(this);
  }
  scheduledPublishError() {
    return Model.attribute('scheduledPublishError').call(this);
  }
  isDraft() {
    return !!Model.attribute('isDraft').call(this);
  }
  isScheduled() {
    return this.isDraft() && !!this.scheduledPublishAt();
  }
  canPublish() {
    return Model.attribute('canPublish').call(this);
  }
  canUnpublish() {
    return Model.attribute('canUnpublish').call(this);
  }
  publish(body) {
    if (body === void 0) {
      body = {};
    }
    const id = this.id();
    if (!id) {
      return Promise.reject(new Error('Cannot publish an unsaved poll.'));
    }
    return app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/polls/").concat(id, "/publish"),
      body: {
        data: {
          attributes: body
        }
      }
    }).then(payload => {
      app.store.pushPayload(payload);
      return this;
    });
  }
  unpublish() {
    const id = this.id();
    if (!id) {
      return Promise.reject(new Error('Cannot unpublish an unsaved poll.'));
    }
    return app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/polls/").concat(id, "/unpublish")
    }).then(payload => {
      app.store.pushPayload(payload);
      return this;
    });
  }
}
flarum.reg.add('fof-polls', 'forum/models/Poll', Poll);